
export default {
  routeImporter: {
    'loadRouteFile': 'Importa file',
    'failedToLoadFile': 'Impossibile caricare il file selezionato. Assicurati che il file non sia corrotto e sia in uno dei formati accettati',
    'acceptedImportTypes': 'Formati accettati',
    'dictDefaultMessage': 'Trascina un file con itinerario da importare o clicca qui',
    'dictFallbackMessage': 'Browser non supportato',
    'dictFileTooBig': 'File troppo grande',
    'dictInvalidFileType': 'Tipo di file non valido',
    'dictCancelUpload': 'Cancella upload',
    'dictUploadCanceled': 'Upload Cancellato',
    'dictRemoveFile': 'Rimuovi file'
  }
}
